<template>
  <v-card outlined tile class="flex d-flex flex-column">
    <v-card-title>
      <span v-if="address.type in addressTypeMap">
        {{ addressTypeMap[address.type] }}
      </span>
      <span v-else>
        {{ address.type }}
      </span>
    </v-card-title>
    <v-card-text>
      <div v-for="(addressLine, i) in address.addressLines" :key="`address_line_${i}`">
        {{ addressLine }}
      </div>
      <div>
        {{ address.localityName }}, {{ address.postcode}}, {{ address.state }}, {{ address.country || 'Australia' }}
      </div>
    </v-card-text>
    <v-spacer/>
    <v-card-actions>
      <slot></slot>
    </v-card-actions>
  </v-card>
</template>

<script>
import { AddressType } from '@mymsa/common'

const addressTypeMap = {
  [AddressType.ADMIN]: 'Administration address',
  [AddressType.BUSINESS]: 'Business address',
  [AddressType.COLD_STORE]: 'Cold store address',
  [AddressType.DELIVERY]: 'Delivery address',
  [AddressType.EXPORT]: 'Export address',
  [AddressType.FACTORY]: 'Factory address',
  [AddressType.FEEDLOT]: 'Feedlot address',
  [AddressType.HEAD_OFFICE]: 'Head office address',
  [AddressType.LAIRAGE]: 'Lairage address',
  [AddressType.LEGAL]: 'Legal address',
  [AddressType.LIVESTOCK_OFFICE]: 'Livestock office address',
  [AddressType.MAIL_SERVICE]: 'Mail service address',
  [AddressType.OFFICE]: 'Office / registered address',
  [AddressType.PLANT]: 'Plant address',
  [AddressType.POSTAL]: 'Postal address',
  [AddressType.PROPERTY]: 'Property address',
  [AddressType.REGIONAL_OFFICE]: 'Regional office address',
  [AddressType.REGISTER]: 'Register address',
  [AddressType.RETAIL]: 'Retail address',
  [AddressType.SALES]: 'Sales address',
  [AddressType.SALEYARD]: 'Saleyard address',
  [AddressType.STATE_OFFICE]: 'State office address',
  [AddressType.WAREHOUSE]: 'Warehouse address',
  [AddressType.WHOLESALE]: 'Wholesale address'
}

export default {
  name: 'Address',

  props: {
    address: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    addressTypeMap
  })
}
</script>
